import axios from 'axios'
import store from '../store'

class Config {
  getConfig = () => axios.get('')
  isReserveActive () {
    const _store = store
    const orderReserveConfig = _store.getters.CheckoutConfig.paymentInformationConfig.order_reserve_config
    if (orderReserveConfig.enabled) {
      const endDate = new Date(orderReserveConfig.end_date)
      const now = new Date()

      if (endDate > now) {
        return true
      } else {
        return false
      }
    }
    return false
  }
}

export default new Config()
